import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Button,
  FormGroup,
  Checkbox,
  FormControlLabel,
  Popover,
  MenuItem,
  Menu,
  Tabs,
  Tab
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import FilterListIcon from "../../assets/filter.svg";
import Label from "../Label/Label";

export default function LimitsListHeader({
  text,
  buttonText,
  onButtonClick,
  filterOptionsGroup1,
  filterOptionsGroup2,
  selectedFilters,
  handleCheckboxChange,
  isButton = false,
  isMultiOptinButton = false,
  handleSearch,
  search,
  popupFilter = false,
  isAuditLogs = false,
  handlePopupFilter,
  viewAuditLogs,
  auditText,
  viewLogs,
  onBackClick,
  options,
  selectedOption,
  setOption,
  placeholder = "Search by parameter name",
  showTab = false,
  isFillterIcon = true,
  tabValue,
  setTabValue
}) {
  const [anchorFilter, setAnchorFilter] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);


  const openFilter = Boolean(anchorFilter);
  const openChartMenu = Boolean(anchorEl);

  const handleClickFilter = (event) => {
    setAnchorFilter(event.currentTarget);
  };

  const handleCloseFilter = () => {
    setAnchorFilter(null);
  };

  return (
    <Box
      sx={{
        borderBottom: "1px solid #e0e0e0",
        px: 3.5,
        pt: 1
      }}
    >
      {/* Top Row */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        pb={1}
      >
        <Box>
          {text === "Audit Trail" ? (
            <Button
              startIcon={<ArrowBackIcon />}
              sx={{
                textTransform: "none",
                borderRadius: "20px",
                px: 2,
                py: 0.5,
                backgroundColor: "#E9EAEB",
                color: "black",
              }}
              onClick={onBackClick}
            >
              Back
            </Button>
          ) : (
            <Box sx={{ display: "flex", alignItems: 'center', gap: 2 }}>
              <Typography variant="subtitle1" fontWeight="600">
                {text}
              </Typography>

              {/* ✅ Tabs Added Here */}
              {showTab && <Tabs
                value={tabValue}
                onChange={(e, newValue) => setTabValue(newValue)}
                sx={{
                  minHeight: 36,
                  "& .MuiTab-root": {
                    textTransform: "none",
                    minHeight: 36,
                    fontSize: 14,
                    fontWeight: 500,
                    p: 0.5,
                    px: 2
                  }
                }}
              >
                <Tab label="Parameter" />
                <Tab label="Parameter Phase" />
                <Tab label="Parameter Table" />
              </Tabs>}
            </Box>
          )}
        </Box>

        {/* Right Section */}
        <Box display="flex" alignItems="center" gap={2}>
          <TextField
            size="small"
            placeholder={placeholder}
            variant="outlined"
            value={search}
            onChange={handleSearch}
            InputProps={{
              sx: { fontSize: "14px" },
              endAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />

          {isFillterIcon && <Button
            onClick={popupFilter ? handlePopupFilter : handleClickFilter}
            startIcon={<img src={FilterListIcon} alt="Filter" />}
            sx={{
              color: "black",
              textTransform: "none",
              fontSize: 14,
              fontWeight: 400,
            }}
          >
            {popupFilter ? "Filter" : "Parameter Filter"}
          </Button>}
          {isAuditLogs && (
            <Button
              variant={!viewLogs ? "outlined" : "contained"}
              sx={{
                // backgroundColor: "#154D8F",
                textTransform: "none",
                // "&:hover": { backgroundColor: "#1565c0" },
                fontSize: 14,
                fontWeight: 400,
              }}
              onClick={viewAuditLogs}
            >
              {auditText}
            </Button>
          )}
          {/* Filter Popover */}
          <Popover
            open={openFilter}
            anchorEl={anchorFilter}
            onClose={handleCloseFilter}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            sx={{ mt: 1 }}
          >
            <Box p={2} minWidth={150}>
              <FormGroup>
                {filterOptionsGroup1?.map((option) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        checked={selectedFilters?.includes(option)}
                        onChange={() => handleCheckboxChange(option)}
                      />
                    }
                    label={option}
                  />
                ))}

                {filterOptionsGroup2?.length > 0 && <hr />}

                {filterOptionsGroup2?.map((option) => (
                  <FormControlLabel
                    key={option}
                    control={
                      <Checkbox
                        checked={selectedFilters?.includes(option)}
                        onChange={() => handleCheckboxChange(option)}
                      />
                    }
                    label={option}
                  />
                ))}
              </FormGroup>
            </Box>
          </Popover>

          {isButton && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={onButtonClick}
              sx={{
                backgroundColor: "#3882DB",
                textTransform: "none",
                fontSize: 14,
                fontWeight: 400,
                "&:hover": { backgroundColor: "#1565c0" },
              }}
            >
              {buttonText}
            </Button>
          )}

          {isMultiOptinButton && (
            <>
              <Button
                variant="contained"
                onClick={(e) => setAnchorEl(e.currentTarget)}
                sx={{
                  textTransform: "none",
                  minWidth: 142,
                  backgroundColor: "#3882DB",
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  "&:hover": { backgroundColor: "#2f6fb8" },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <AddIcon />
                  <Label text={"Add"} color="inherit" />
                </Box>
                <ArrowDropDownIcon />
              </Button>

              <Menu
                anchorEl={anchorEl}
                open={openChartMenu}
                onClose={() => setAnchorEl(null)}
                PaperProps={{
                  sx: {
                    backgroundColor: "#3882DB",
                    color: "#fff",
                    mt: 1,
                  },
                }}
              >
                {options?.map((chart) => (
                  <MenuItem
                    key={chart.value}
                    onClick={() => {
                      setAnchorEl(null);
                      setOption(chart.value);
                    }}
                    sx={{
                      color: "#fff",
                      "&:hover": { backgroundColor: "#2f6fb8" },
                    }}
                  >
                    <Label text={chart.label} color="inherit" />
                  </MenuItem>
                ))}
              </Menu>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
